(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kl-360"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.kl360) return;
    window.kl360 = true;

    function btn(e) {
      return e.target && e.target.closest ? e.target.closest('[data-kl-360]') : null;
    }

    // wideo 360 jest odroczone (poster + przycisk play) - po przelaczeniu slajdu startujemy je sami,
    // bez dzwieku i w petli, zeby przycisk dawal od razu obrot produktu
    function odtworz(gal) {
      var proby = 0;
      var t = setInterval(function () {
        proby++;
        var slajd = gal.querySelector('slideshow-slide[class*="--video"]');
        if (slajd) {
          var poster = slajd.querySelector('.deferred-media__poster-button');
          if (poster && poster.offsetParent !== null) poster.click();
          var v = slajd.querySelector('video');
          if (v) {
            v.muted = true;
            v.loop = true;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
            clearInterval(t);
            return;
          }
        }
        if (proby > 20) clearInterval(t);
      }, 150);
    }

    // przycisk ma stac tuz na lewo od przelacznika swiatla i na tej samej wysokosci; napis przelacznika
    // zmienia sie ("Wlacz swiatlo" / "Wylacz swiatlo"), wiec pozycje przeliczamy po kazdej zmianie
    function ustawObokPrzelacznika() {
      document.querySelectorAll('[data-kl-360]').forEach(function (b) {
        var slajd = b.closest('slideshow-slide') || b.parentElement;
        var ls = slajd && slajd.querySelector('.kl-ls__btn--pdp');
        if (!ls || !b.offsetParent) return;
        var kont = b.offsetParent.getBoundingClientRect();
        var r = ls.getBoundingClientRect();
        if (!r.width) return;
        b.style.top = Math.round(r.top - kont.top) + 'px';
        b.style.right = Math.round(kont.right - r.left + 8) + 'px';
        b.style.minHeight = Math.round(r.height) + 'px';
      });
    }

    window.addEventListener('resize', ustawObokPrzelacznika);
    new MutationObserver(ustawObokPrzelacznika).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed', 'class'] });
    setTimeout(ustawObokPrzelacznika, 300);
    setTimeout(ustawObokPrzelacznika, 1200);

    // slajd galerii otwiera zoom po kliknieciu - klikniecie przycisku nie moze tam dojsc
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (typ) {
      window.addEventListener(typ, function (e) {
        if (btn(e)) e.stopPropagation();
      }, { capture: true, passive: true });
    });

    window.addEventListener('click', function (e) {
      var b = btn(e);
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var gal = b.closest('media-gallery') || document.querySelector('media-gallery');
      var idx = b.getAttribute('data-kl-360');
      if (!gal || idx === null || idx === '') return;
      // miniatury i kropki motywu maja on:click="/select/<index>" - klikamy ten, ktory jest widoczny
      // (kolejnosc slajdow w DOM bywa inna niz indeksy kontrolek, dlatego indeks idzie z Liquida)
      var cele = gal.querySelectorAll('[on\\:click$="/select/' + idx + '"]');
      var klikniety = null;
      for (var j = 0; j < cele.length && !klikniety; j++) {
        if (cele[j].offsetParent !== null) klikniety = cele[j];
      }
      if (!klikniety && cele.length) klikniety = cele[0];
      if (!klikniety) return;
      klikniety.click();
      odtworz(gal);
    }, { capture: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kl-belka-sticky"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.klBelkaC) return;
    window.klBelkaC = true;

    var mobile = window.matchMedia('(max-width: 749px)');
    function zl(gr) {
      var s = (Math.round(gr) / 100).toFixed(2).split('.');
      return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + s[1] + ' zł';
    }
    function produkty(n) {
      var m10 = n % 10, m100 = n % 100;
      return m10 >= 2 && m10 <= 4 && !(m100 >= 12 && m100 <= 14) ? 'produkty' : 'produktów';
    }
    function belka() {
      var all = document.querySelectorAll('[data-kl-belka]');
      return all.length ? all[all.length - 1] : null;
    }
    function kolumna() { return document.querySelector('.product-details'); }
    function natywny() {
      var k = kolumna();
      return k && (k.querySelector('add-to-cart-component button[name="add"]') || k.querySelector('button[name="add"]'));
    }
    function iloscLampy() {
      var k = kolumna();
      var p = k && k.querySelector('product-form-component input[name="quantity"], input[name="quantity"]');
      var n = parseInt(p && p.value, 10);
      return n >= 1 ? n : 1;
    }
    // pole wyboru zarowki w bloku "Dobierz zarowke" (kl-f-zarowki) - zrodlo prawdy, kl-f.js dodaje zaznaczone
    function cbStrony(dod) {
      return dod ? document.querySelector('.kl-f-zar [data-kl-f-zar][data-id="' + dod.dataset.id + '"]') : null;
    }
    function iloscZar(dod, cb) {
      var p = cb && cb.closest('.kl-f-zar__poz') && cb.closest('.kl-f-zar__poz').querySelector('[data-kl-f-zar-ilosc]');
      var n = parseInt((p && p.value) || dod.dataset.ile, 10);
      return n >= 1 ? n : 1;
    }

    function odswiez() {
      var b = belka();
      if (!b) return;
      var cena = Number(b.dataset.cena || 0), srp = Number(b.dataset.srp || 0);
      var q = iloscLampy();
      var dod = b.querySelector('[data-kl-belka-dod]');
      var cb = cbStrony(dod);
      var zarN = 0, zarSuma = 0;
      if (dod) {
        // bez pola na stronie (blok zarowek ukryty) przelacznik nie ma czego dodac - chowamy
        dod.hidden = !cb;
        if (cb) {
          var tg = dod.querySelector('[data-kl-belka-tg]');
          var n = iloscZar(dod, cb);
          tg.checked = cb.checked;
          dod.classList.toggle('is-on', cb.checked);
          dod.querySelector('[data-kl-belka-dile]').textContent = n;
          dod.querySelector('[data-kl-belka-dcena]').textContent = zl(Number(dod.dataset.cena) * n);
          if (cb.checked) { zarN = n; zarSuma = Number(dod.dataset.cena) * n; }
        }
      }
      var gora = b.querySelector('[data-kl-belka-gora]'), teraz = b.querySelector('[data-kl-belka-teraz]'), dol = b.querySelector('[data-kl-belka-dol]');
      var promo = srp > cena;
      var badge = promo ? '<span class="kl-belka__badge">-' + Math.round((srp - cena) * 100 / srp) + '%</span> ' : '';
      if (zarN > 0 || q > 1) {
        gora.textContent = mobile.matches ? 'Razem' : (zarN > 0 ? 'Razem z ' + (zarN === 1 ? 'żarówką' : 'żarówkami') : 'Razem');
        teraz.textContent = zl(cena * q + zarSuma);
        dol.className = 'kl-belka__lbl';
        dol.innerHTML = (q > 1 ? q + ' x ' : 'lampa ') + (promo ? '<s class="kl-belka__stara">' + zl(srp) + '</s> ' : '') + zl(cena);
      } else {
        gora.innerHTML = promo ? badge + '<s class="kl-belka__stara">' + zl(srp) + '</s>' : '';
        teraz.textContent = zl(cena);
        dol.className = 'kl-belka__lbl kl-belka__lbl--osz';
        dol.textContent = promo ? 'oszczędzasz ' + zl(srp - cena) : '';
      }
      var t = b.querySelector('[data-kl-belka-btn-t]'), btn = b.querySelector('[data-kl-belka-btn]');
      if (t && !btn.disabled) {
        var razem = q + zarN;
        t.textContent = zarN > 0 ? 'Dodaj ' + razem + ' ' + produkty(razem) + (mobile.matches ? ' do koszyka' : '') : (t.getAttribute('data-def') || 'Dodaj do koszyka');
      }
    }

    function pokaz(tak) {
      var b = belka();
      if (!b) return;
      if (tak === b.hasAttribute('data-widoczna')) return;
      if (tak) {
        b.hidden = false;
        b.setAttribute('aria-hidden', 'false');
        odswiez();
        // hidden -> display, dopiero potem transform (inaczej przejscie nie zagra)
        requestAnimationFrame(function () { requestAnimationFrame(function () { b.setAttribute('data-widoczna', ''); }); });
      } else {
        b.removeAttribute('data-widoczna');
        b.setAttribute('aria-hidden', 'true');
        setTimeout(function () { if (!b.hasAttribute('data-widoczna')) b.hidden = true; }, 300);
      }
    }

    // belka pokazuje sie, gdy prawdziwy przycisk wyjedzie z ekranu w GORE (sprawdzane przy przewijaniu,
    // bo przycisk jest podmieniany przy zmianie wariantu)
    var czeka = false;
    function sprawdz() {
      czeka = false;
      var p = natywny();
      if (!p) return pokaz(false);
      var r = p.getBoundingClientRect();
      pokaz(r.bottom < 0);
    }
    function naScroll() { if (!czeka) { czeka = true; requestAnimationFrame(sprawdz); } }
    window.addEventListener('scroll', naScroll, { passive: true });
    window.addEventListener('resize', naScroll);
    mobile.addEventListener && mobile.addEventListener('change', odswiez);

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('[data-kl-belka-tg]')) {
        var dod = t.closest('[data-kl-belka-dod]'), cb = cbStrony(dod);
        if (cb && cb.checked !== t.checked) {
          cb.checked = t.checked;
          cb.dispatchEvent(new Event('change', { bubbles: true }));
        }
        odswiez();
        return;
      }
      if (t.matches('[data-kl-f-zar], [data-kl-f-zar-ilosc], input[name="quantity"]')) odswiez();
    });
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      if (t.closest('[data-kl-f-zar-krok], quantity-selector-component button, .quantity-selector button')) {
        setTimeout(odswiez, 50);
        return;
      }
      var btn = t.closest('[data-kl-belka-btn]');
      if (!btn || btn.disabled) return;
      var p = natywny();
      if (p && !p.disabled) p.click();
      // kl-f.js odznacza zarowki po dodaniu - przelacznik wraca do stanu strony
      setTimeout(odswiez, 1500);
      setTimeout(odswiez, 4000);
    });
    document.addEventListener('cart:update', function () { setTimeout(odswiez, 300); });

    function start() {
      odswiez();
      sprawdz();
      // nowa kopia belki po przerysowaniu kolumny (zmiana wariantu)
      var k = document.querySelector('.product-information') || document.body;
      var t = 0;
      new MutationObserver(function (m) {
        // zmiany w samej belce (nasze odswiez) pomijamy - inaczej petla
        var obce = m.some(function (x) { return !(x.target.closest && x.target.closest('[data-kl-belka]')); });
        if (!obce) return;
        clearTimeout(t);
        t = setTimeout(function () { odswiez(); sprawdz(); }, 150);
      }).observe(k, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kl-filtry-przelacznik"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.klFiltry) return;
    window.klFiltry = true;

    // nowy klucz po zmianie domyslnego stanu: filtry maja byc widoczne, dopoki klient sam ich nie schowa
    var KLUCZ = 'kl-filtry-ukryte-v2';

    function etykieta(schowane) {
      return schowane ? 'Pokaż filtry' : 'Ukryj filtry';
    }

    // Kolekcje powyzej 5000 produktow nie dostaja z Shopify zadnych filtrow - zostaje pusta kolumna,
    // ktora chowa nasz starszy skrypt (blok kl_cdesc). Przycisk nie ma tam czego przelaczac, wiec go nie ma.
    function maFiltry() {
      // KL perf 08.10.2026: lista filtrow jest jedna i na telefonie bywa przeniesiona do szuflady (kl-facety.js)
      return !!document.querySelector('.collection-wrapper .facets__filters-wrapper input');
    }

    function zbuduj() {
      var wrapper = document.querySelector('.collection-wrapper');
      var pasek = wrapper && wrapper.querySelector('.facets--horizontal');
      if (!wrapper || !pasek) return;
      var istniejacy = pasek.querySelector('.kl-filtry-btn');
      if (!maFiltry()) {
        if (istniejacy) istniejacy.remove();
        wrapper.classList.remove('kl-bez-filtrow');
        wrapper.classList.add('kl-brak-filtrow');   // siatka na pelna szerokosc, ale 4 kolumny
        return;
      }
      wrapper.classList.remove('kl-brak-filtrow');
      if (istniejacy) return;

      var schowane = false;
      try { schowane = localStorage.getItem(KLUCZ) === '1'; } catch (e) {}

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kl-filtry-btn';
      btn.innerHTML = '<svg class="kl-filtry-btn__ikona" width="14" height="14" viewBox="0 0 24 24" fill="none" ' +
        'stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M15 5 8 12l7 7"/></svg><span class="kl-filtry-btn__napis"></span>';

      function zastosuj(stan) {
        wrapper.classList.toggle('kl-bez-filtrow', stan);
        btn.querySelector('.kl-filtry-btn__napis').textContent = etykieta(stan);
        btn.setAttribute('aria-expanded', stan ? 'false' : 'true');
        try { localStorage.setItem(KLUCZ, stan ? '1' : '0'); } catch (e) {}
      }

      btn.addEventListener('click', function () {
        zastosuj(!wrapper.classList.contains('kl-bez-filtrow'));
      });

      pasek.insertBefore(btn, pasek.firstChild);
      zastosuj(schowane);
    }

    // filtrowanie i sortowanie przerysowuja cala sekcje - przycisk trzeba wstawic ponownie
    new MutationObserver(zbuduj).observe(document.documentElement, { childList: true, subtree: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', zbuduj);
    else zbuduj();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kl-light-switch-global"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.klLightSwitchGlobal) return;
    window.klLightSwitchGlobal = true;

    function ustawKafelek(cg, on) {
      cg.classList.toggle('kl-ls-on', on);
      // ta sama klasa na product-card - serduszko Swym jest poza .card-gallery, a plaskie
      // selektory sa ok. 18x tansze od has() (pomiar 21.09.2026)
      var karta = cg.closest ? cg.closest('product-card') : null;
      if (karta) karta.classList.toggle('kl-ls-on', on);
      var b = cg.querySelector(':scope > [data-kl-ls-btn]');
      if (b) {
        var etykieta = on ? b.dataset.labelOff : b.dataset.labelOn;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', etykieta);
        b.setAttribute('title', etykieta);
      }
      var img = cg.querySelector(':scope > .kl-ls__img');
      if (on && img && img.loading === 'lazy') img.loading = 'eager';
    }

    // nowe kafelki (filtry, paginacja) dostaja stan globalny raz; pozniej rzadzi ich wlasny przelacznik
    function synchronizuj() {
      var on = document.documentElement.classList.contains('kl-light-on');
      var jestSwiecace = !!document.querySelector('.kl-ls__img');
      document.querySelectorAll('.kl-lsg').forEach(function (b) {
        b.classList.toggle('kl-lsg--pusto', !jestSwiecace);
      });
      document.querySelectorAll('[data-kl-lsg-btn]').forEach(function (b) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.querySelectorAll('.card-gallery:not([data-kl-ls-sync])').forEach(function (cg) {
        if (!cg.querySelector(':scope > .kl-ls__img')) return;
        cg.setAttribute('data-kl-ls-sync', '');
        if (on) ustawKafelek(cg, true);
      });
    }

    // capture na window: przycisk stoi w formularzu filtrow (facets) - klik nie moze go wyslac
    window.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-kl-lsg-btn]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var on = !document.documentElement.classList.contains('kl-light-on');
      document.documentElement.classList.toggle('kl-light-on', on);
      try {
        sessionStorage.setItem('klLight', on ? '1' : '0');
      } catch (err) {}
      document.querySelectorAll('.card-gallery').forEach(function (cg) {
        if (cg.querySelector(':scope > .kl-ls__img')) ustawKafelek(cg, on);
      });
      synchronizuj();
    }, true);

    // filtry/paginacja przerenderowuja siatke - nowe kafelki i nowy przycisk dostaja aktualny stan
    var zaplanowane = false;
    // Obserwator siedzial na document.documentElement z subtree - lapal KAZDA zmiane DOM na
    // stronie, a Swym wstrzykuje serduszka do wszystkich kart przez 5-8 s. Zawezony do siatki
    // produktow i rozlaczany, gdy Swym jest juz gotowy (21.09.2026, walka o INP na kolekcjach).
    var obs = new MutationObserver(function () {
      if (zaplanowane) return;
      zaplanowane = true;
      requestAnimationFrame(function () {
        zaplanowane = false;
        synchronizuj();
        if (document.documentElement.classList.contains('kl-swym-gotowe')) obs.disconnect();
      });
    });
    function podepnij() {
      var cel = document.querySelector('#ProductGridContainer, .product-grid-container, main') ||
                document.documentElement;
      obs.observe(cel, { childList: true, subtree: true });
    }
    podepnij();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', synchronizuj);
    } else {
      synchronizuj();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kl-light-switch"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.klLightSwitch) return;
    window.klLightSwitch = true;

    function przycisk(e) {
      var t = e.target;
      return t && t.closest ? t.closest('[data-kl-ls-btn]') : null;
    }

    // Faza capture na window: karta produktu nawiguje po kliknieciu w dowolne miejsce (product-card.js),
    // a slajd galerii otwiera zoom - klikniecie przelacznika nie moze dojsc do tych handlerow.
    // Delegacja, bo motyw i SA Variants przerenderowuja sekcje.
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (typ) {
      window.addEventListener(typ, function (e) {
        if (przycisk(e)) e.stopPropagation();
      }, { capture: true, passive: true });
    });

    // 04.11.2026: Swym odinstalowany - zaslepka serduszka i czekanie na prawdziwe serce usuniete.
    // Klasa kl-swym-gotowe dalej rozlacza obserwator siatki w kl-light-switch-global (jak po zaladowaniu Swym, 5-8 s).
    setTimeout(function () { document.documentElement.classList.add('kl-swym-gotowe'); }, 8000);

    window.addEventListener('click', function (e) {
      var btn = przycisk(e);
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var root = btn.closest('.product-media-container, .card-gallery') || btn.parentElement;
      var on = !root.classList.contains('kl-ls-on');
      var img = root.querySelector('.kl-ls__img');
      if (img && on && img.loading === 'lazy') img.loading = 'eager';
      root.classList.toggle('kl-ls-on', on);
      // serduszko Swym lezy w rownoleglej galezi product-card > div.swym-...-container,
      // wiec klasa musi trafic takze na product-card (patrz komentarz w stylach wyzej)
      var karta = root.closest ? root.closest('product-card') : null;
      if (karta) karta.classList.toggle('kl-ls-on', on);
      var etykieta = on ? btn.dataset.labelOff : btn.dataset.labelOn;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', etykieta);
      btn.setAttribute('title', etykieta);
      var txt = btn.querySelector('.kl-ls__label');
      if (txt) txt.textContent = etykieta;
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kl-platnosci"] && !Shopify.designMode) return;
  try {
    /* Belka sticky apki Avada renderuje ceny jako "PLN 138.58" (apka nie ma ustawienia formatu waluty,
     sprawdzone w panelu 16.09.2026). Przepisujemy na format sklepu: "138,58 zł".
     UWAGA: apka Avada Boost Sales wygasa 04.10.2026 - po tej dacie belka znika razem z tym kodem. */
  (function () {
    if (window.klBelkaCeny) return;
    window.klBelkaCeny = true;

    function formatuj(el) {
      var m = (el.textContent || '').trim().match(/^PLN\s*([\d\s.,]+)$/i);
      if (!m) return;
      var n = parseFloat(m[1].replace(/\s/g, '').replace(/,/g, ''));
      if (!isFinite(n)) return;
      el.textContent = n.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
    }

    function przejdz() {
      document.querySelectorAll('.Avada-StickyATC-DiscountPrice, .Avada-StickyATC-ActualPrice').forEach(formatuj);
    }

    // belka wstrzykiwana jest po zaladowaniu strony i przerysowywana przy zmianie wariantu
    new MutationObserver(przejdz).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    przejdz();
  })();
  } catch(e) { console.error(e); }
})();

})();
